import { KnownInboxLabel } from "./known-inbox-label";

/** How the inbox names its own QW-AI labels on a conversation. Any other label shows as-is. */
export const inboxLabelDisplayText = {
  [KnownInboxLabel.QW_AI_SUBMISSION]: "Submission",
  [KnownInboxLabel.QW_AI_QUOTE]: "Quote",
  [KnownInboxLabel.QW_AI_FORWARDED]: "Forwarded",
} as const satisfies Partial<Record<KnownInboxLabel, string>>;

const hiddenDisplayLabels = new Set<string>([
  KnownInboxLabel.INBOX,
  KnownInboxLabel.UNREAD,
  KnownInboxLabel.STARRED,
  KnownInboxLabel.SENT,
  KnownInboxLabel.IMPORTANT,
  KnownInboxLabel.SPAM,
  KnownInboxLabel.TRASH,
  KnownInboxLabel.ARCHIVED,
  KnownInboxLabel.DRAFT,
  KnownInboxLabel.ALL_MAIL,
  KnownInboxLabel.CATEGORY_FORUMS,
  KnownInboxLabel.CATEGORY_PERSONAL,
  KnownInboxLabel.CATEGORY_PROMOTIONS,
  "CATEGORY_SOCIAL",
  KnownInboxLabel.CATEGORY_UPDATES,
  KnownInboxLabel.RED_STAR,
  KnownInboxLabel.ORANGE_STAR,
  KnownInboxLabel.YELLOW_STAR,
  KnownInboxLabel.GREEN_STAR,
  KnownInboxLabel.BLUE_STAR,
  KnownInboxLabel.PURPLE_STAR,
  KnownInboxLabel.RED_CIRCLE,
  KnownInboxLabel.ORANGE_CIRCLE,
  KnownInboxLabel.YELLOW_CIRCLE,
  KnownInboxLabel.GREEN_CIRCLE,
  KnownInboxLabel.BLUE_CIRCLE,
  KnownInboxLabel.PURPLE_CIRCLE,
  KnownInboxLabel.QW_AI_PROCESSING,
]);

// Own keys only: a user label named after an Object.prototype member ("constructor") must stay a string.
const hasDisplayText = (label: string): label is keyof typeof inboxLabelDisplayText =>
  Object.hasOwn(inboxLabelDisplayText, label);

const displayTextFor = (label: string): string => (hasDisplayText(label) ? inboxLabelDisplayText[label] : label);

const isHiddenDisplayLabel = (label: string) => hiddenDisplayLabels.has(label);

export const getDisplayLabels = (labels: readonly string[]) =>
  Array.from(new Set(labels.filter((label) => !isHiddenDisplayLabel(label)).map((label) => displayTextFor(label))));
